<template>
  <ul class="chart-pool">
    <li class="chart-item" v-for="(chart, index) in chartList" :key="index">
      <div class="chart-content" @click="selectChart(chart)">
        <IconChartLine size="20" v-if="chart === 'line'" />
        <IconChartHistogram size="20" v-else-if="chart === 'bar'" />
        <IconChartPie size="20" v-else-if="chart === 'pie'" />
        <IconChartHistogramOne size="20" v-else-if="chart === 'column'" />
        <IconChartLineArea size="20" v-else-if="chart === 'area'" />
        <IconChartRing size="20" v-else-if="chart === 'ring'" />
        <IconChartScatter size="20" v-else-if="chart === 'scatter'" />
        <IconRadarChart size="20" v-else-if="chart === 'radar'" />

        <div class="name">{{ CHART_TYPE_MAP[chart] }}</div>
      </div>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { ChartType } from '@/types/slides'
import { CHART_TYPE_MAP } from '@/configs/chart'

const emit = defineEmits<{
  (event: 'select', payload: ChartType): void
}>()

const chartList: ChartType[] = ['bar', 'column', 'line', 'area', 'scatter', 'pie', 'ring', 'radar']

const selectChart = (chart: ChartType) => {
  emit('select', chart)
}
</script>

<style lang="scss" scoped>
.chart-pool {
  width: 280px;
  padding: 4px 0;

  @include flex-grid-layout();
}
.chart-item {
  @include flex-grid-layout-children(4, 24%);

  height: 50px;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
}
.chart-content {
  @include absolute-0();

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #999;
  gap: 3px;

  &:hover {
    color: $themeColor;
  }

  .name {
    font-size: 10px;
    line-height: 1.2;
    text-align: center;
    white-space: nowrap;
  }
}
</style>